<!--  自定义vue-quill-editor的主要文件 -->
<template>
  <div v-loading="imageLoading" element-loading-text="请稍等，图片上传中">
    <quill-editor
      ref="myTextEditor"
      v-model="content"
      :options="quillOption"
      @change="onEditorChange($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    >
    </quill-editor>
    <!-- 这个是elementui的上传，把它display:none -->
    <el-upload
      :before-upload="beforeAvatarUpload"
      :class="name"
      :http-request="upload_img"
      :on-progress="onProgress"
      :on-success="handleAvatarSuccess"
      :show-file-list="false"
      action="#"
      multiple
      style="display:none;"
    >
    </el-upload>
  </div>
</template>
<script>
import index from "./quill-editor.js";

export default {
  ...index
};
</script>

<style lang="less" scoped>
@import url("./quill-editor.less");
</style>
